import http from '@/lib/http.js';
import Pusher from 'pusher-js';

let pusher;
let socketId;

const APP_KEY = '17d834d1a97439f4f606';
const APP_CLUSTER = 'mt1';

var store = {
	namespaced: true,
	state: {
		channel: null,
		errors: [],
		realtimeConnectionState: 'default'
	},
	getters: {
		user: function(state, getters, rootState, rootGetters) {
			return rootGetters['user/user'];
		},
		realtimeConnectionState: function(state) {
			return state.realtimeConnectionState;
		}
	},
	mutations: {
		PUSH_ERROR: function(state, error) {
			state.errors.push(error);
			if (state.errors.length > 3) {
				state.errors.shift();
			}
		},
		SET_UPDATE_TRIGGER: function(state) {},
		SET_REALTIME_CONNECTION_STATE: function(state, status) {
			state.realtimeConnectionState = status;
		}
	},
	actions: {
		pushError: function(context, states) {
			context.commit('PUSH_ERROR', states.current);
			if (
				context.state.errors[context.state.errors.length - 1] ===
					'connecting' &&
				context.state.errors[context.state.errors.length - 2] === 'connected'
			) {
				context.dispatch('message/onConnectionWarning', null, { root: true });
			}
			if (
				context.state.errors[context.state.errors.length - 1] ===
					'unavailable' &&
				context.state.errors[context.state.errors.length - 2] === 'connecting'
			) {
				context.dispatch('message/onConnectionLost', null, { root: true });
			}
			if (
				context.state.errors[context.state.errors.length - 1] === 'connected' &&
				context.state.errors[context.state.errors.length - 3] === 'unavailable'
			) {
				context.dispatch('message/onReconnection', null, { root: true });
			}
			if (
				context.state.errors[context.state.errors.length - 1] === 'connected' &&
				context.state.errors[context.state.errors.length - 3] === 'connecting'
			) {
				context.dispatch('user/refreshToken', null, { root: true });
				context.dispatch('message/onReconnection', null, { root: true });
			}
		},
		async setupEventListeners(context) {
			pusher = new Pusher(APP_KEY, {
				cluster: APP_CLUSTER,
				authEndpoint: `${context.rootState.baseUrl}/pusher/auth`
			});
			let channelName = `private-${context.getters.user._id}`;
			context.state.channel = pusher.subscribe(channelName);
			pusher.connection.bind('state_change', function(states) {
				context.dispatch('pushError', states);
				context.commit('SET_REALTIME_CONNECTION_STATE', states.current);
			});
			pusher.connection.bind('connected', () => {
				//context.commit('ui/SET_UPDATE_TRIGGER', null, { root: true });
				socketId = pusher.connection.socket_id;
				http.setHeader('x-socket-id', socketId);
			});

			context.state.channel.bind('user:updated', data => {
				context.dispatch('user/refreshToken', null, { root: true });
			});
			context.state.channel.bind('bucket:updated', data => {
				context.commit('SET_UPDATE_TRIGGER');
				context.commit('bucket/UPDATE_BUCKET', data, { root: true });
			});
			context.state.channel.bind('bucket:added', data => {
				context.commit('SET_UPDATE_TRIGGER');
				context.commit('bucket/ADD_BUCKET', data, { root: true });
			});
			context.state.channel.bind('bucket:deleted', data => {
				context.commit('SET_UPDATE_TRIGGER');
				context.commit('bucket/REMOVE_BUCKET', data, { root: true });
			});
			context.state.channel.bind('folder:updated', data => {
				context.commit('SET_UPDATE_TRIGGER');
				context.commit('folder/UPDATE_FOLDER', data, { root: true });
			});
			context.state.channel.bind('folder:added', data => {
				context.commit('SET_UPDATE_TRIGGER');
				context.commit('folder/ADD_FOLDER', data, { root: true });
			});
			context.state.channel.bind('folder:deleted', data => {
				context.commit('SET_UPDATE_TRIGGER');
				context.commit('folder/REMOVE_FOLDER', data, { root: true });
			});
			context.state.channel.bind('note:added', data => {
				context.commit('SET_UPDATE_TRIGGER');
				context.commit('note/ADD_NOTE', data, { root: true });
			});
			context.state.channel.bind('note:updated', data => {
				context.commit('SET_UPDATE_TRIGGER');
				context.commit('note/UPDATE_NOTE', data, { root: true });
			});
			context.state.channel.bind('note:deleted', data => {
				context.commit('SET_UPDATE_TRIGGER');
				context.commit('note/REMOVE_NOTE', data, { root: true });
			});
			context.state.channel.bind('note:updated:bulk', data => {
				context
					.dispatch('note/fetchSpecificNotes', data, { root: true })
					.then(notes => {
						context.commit('note/UPDATE_NOTE_BULK', notes, { root: true });
					});
			});
			context.state.channel.bind('note:deleted:bulk', data => {
				context.commit('note/REMOVE_NOTE_BULK', data, { root: true });
			});

			return true;
		},
		disconnect: function(context) {
			if (pusher) {
				pusher.disconnect();
			}
		}
	}
};

export default store;
